import { useTenantedApplicationConfig } from '../../../contexts/tenantedApplicationConfig';
import { WorkflowSchema } from '../../../types';
import { useWorkflowNameOrFail } from '../useWorkflowNameOrFail';

export const useActiveWorkflowSchema = (): WorkflowSchema => {
  const config = useTenantedApplicationConfig();
  const workflowName = useWorkflowNameOrFail();

  const { schemas } = config;

  if (workflowName in schemas) return schemas[workflowName];

  throw new Error(
    `Cannot return active workflow schema: schema for '${workflowName}' is missing.`,
  );
};
